// Auto-generated cornerstone translation for no.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:52:37.668240+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Hestestyring app: beste valg for 2026 | EquiSight",
      description: "Sammenlign hestestyring-apper for eier, stall og avl. Oppdag hvorfor EquiSight er den komplette appen for din hest.",
      keywords: [
        "hestestyring app",
        "stallstyring app",
        "heste loggbok app",
        "app for å styre flere hester",
        "hoppe drektighet app",
        "avl app hester",
        "beste hestestyring app",
      ],
    },
    hero: {
      eyebrow: "Valgguide · hestestyring programvare",
      breadcrumbLabel: "Hestestyring app",
      title: "Hestestyring app: den komplette valgguiden for eiere, staller og avlere.",
      intro: "Ikke bare en liste med funksjoner — en ærlig sammenligning, en valgguide og et blikk på hva en hestestyring app virkelig må kunne i 2026. For én hest, for en hel stall, eller for din avlsvirksomhet.",
      pills: [
        {
          icon: "Users",
          label: "For eiere",
        },
        {
          icon: "Building2",
          label: "For staller",
        },
        {
          icon: "Baby",
          label: "For avlere",
        },
        {
          icon: "Share2",
          label: "For team",
        },
      ],
      ctas: [
        {
          label: "Start gratis med 1 hest",
          href: "#start",
          primary: true,
        },
        {
          label: "Til sammenligningstabell",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor en hestestyring app blir stadig viktigere.",
      lead: "Hestestyring er i praksis fragmentert: WhatsApp, kalender, Excel, bilder på telefonen, et papirpass, løse fakturaer og muntlige avtaler. Upraktisk allerede med én hest. Med flere hester, avlsvirksomhet eller delt omsorg oppstår det hull, tapte avtaler og diskusjoner.",
      items: [
        "Hvor var den vaksinasjonsdatoen igjen?",
        "Hvem betalte hovslageren?",
        "Hvilken hoppe skal sjekkes i dag?",
        "Har treneren lest instruksjonen fra forrige uke?",
        "Har jeg virkelig lagret det bildedokumentet?",
        "Stemmer fôrplanen som henger i stallen fortsatt?",
      ],
    },
    what: {
      title: "Hva er en hestestyring app?",
      lead: "En hestestyring app er i bunn og grunn en digital journal per hest. Ingen fragmenterte notater, men ett sted for helse, trening, fôring, dokumenter, planlegging, påminnelser, kostnader, bilder, videoer og delt tilgang. Alle rundt hesten ser den samme, oppdaterte informasjonen.",
      targetGroupsTitle: "Hvem er en hestestyring app beregnet for?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privat eier",
          body: "Én hest, én journal — helse, planlegging og historikk i lommen.",
        },
        {
          icon: "Users",
          title: "Eier med flere hester",
          body: "Separate profiler, separat planlegging, delt oppgaveliste for hele teamet.",
        },
        {
          icon: "Building2",
          title: "Pensjonsstall & rideskole",
          body: "Eiertilgang, stell-instruksjoner, delt kalender og oppgaver.",
        },
        {
          icon: "Baby",
          title: "Avlsvirksomhet",
          body: "Hoppesyklus, drektighet, hingstedata, stamtavle og føllutviding.",
        },
        {
          icon: "Target",
          title: "Trenere",
          body: "Oversikt per hest, loggføre økter, sette mål, analysere videoer.",
        },
        {
          icon: "ClipboardList",
          title: "Fagpersoner",
          body: "Hovslagere, tannleger, fysioterapeuter eller veterinærer — jobber fra samme journal.",
        },
      ],
    },
    criteria: {
      title: "Hva må en god hestestyring app inneholde?",
      lead: "En app er ikke bare pen å se på — den må fungere praktisk i hverdagen. Fem elementer som ikke må mangle i valget for 2026.",
      items: [
        {
          icon: "FileText",
          title: "Hestejournal per hest",
          body: "Data, alder, rase, passinformasjon, eier, stall, bilder og dokumenter — alt koblet til én hesteprofil.",
        },
        {
          icon: "Heart",
          title: "Helse og stell",
          body: "Vaksiner, orming, hovslagere, tannlege, veterinær, behandlinger, medisin og automatiske påminnelser før forfallsdato.",
        },
        {
          icon: "Activity",
          title: "Trening og fremgang",
          body: "Loggføre treninger, notater, videoer, konkurranseresultater, mål og fremgang per disiplin eller per hest.",
        },
        {
          icon: "Apple",
          title: "Fôring og styring",
          body: "Fôrplaner, tilskudd, grovfôr, vekt, kroppskondisjonscore og den daglige rutinen stallen må kjenne til.",
        },
        {
          icon: "Share2",
          title: "Del med andre",
          body: "Tilgang for eier, stallansatt, trener, stallvert eller fagperson — med rettighetsstyring tilpasset hver rolle.",
        },
        {
          icon: "Calendar",
          title: "Planlegging og påminnelser",
          body: "En delt kalender med oppgaver, automatiske påminnelser og bekreftelse slik at ingenting faller mellom to stoler.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andre hestestyring-apper.",
      lead: "Det norske markedet fylles for øyeblikket av Stalmanager, LogMyHorse, EquineM og Happie Horse. De har alle sine sterke sider. Vi stiller de mest etterspurte funksjonene opp mot hverandre — ærlig og basert på offentlig tilgjengelig informasjon.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Start gratis",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Flere hester",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Helsejournal",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Trening & fremgang",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fôring & tilskudd",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planlegging & påminnelser",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenter per hest",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Del med team & rettigheter",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Avlsmodul (komplett)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hoppesyklus",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Drektighetsplanlegging + ultralyd",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Føllutviling",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrering av fagpersoner",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach-innsikt",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Egnet for eier",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Egnet for avl",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Egnet for stall/rideskole",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Sammenligning basert på offentlig tilgjengelige funksjoner per januar 2026. Konkurrentene er også gode verktøy; EquiSight er bygget for å kombinere alle moduler i én app.",
    },
    why: {
      title: "Hvorfor EquiSight er annerledes.",
      lead: "En loggbok registrerer. EquiSight kombinerer hestestyring, trening, fôring, helse, konkurranser, fagpersoner og avl i én moderne app — og går et skritt videre med innsikt.",
      points: [
        {
          icon: "Heart",
          title: "Én app for hele hestens liv",
          body: "Fra føll til sportshest, avlshoppe eller pensjonshest. Journalen vokser med hesten din — ingenting forsvinner underveis.",
        },
        {
          icon: "Sparkles",
          title: "Ikke bare data, men også mønstre",
          body: "EquiCoach kombinerer utvikling, tilbakevendende plager, trening og fôring — slik at du ser signaler i tide, ikke løse meldinger.",
        },
        {
          icon: "Share2",
          title: "Bygget for samarbeid",
          body: "Eier, stallvert, trener, hovslagere og andre fagpersoner jobber fra samme hestejournal — med rettighetene som passer deres rolle.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nisje · avl",
      title: "Hestestyring for avlsvirksomheter.",
      lead: "Mange konkurrenter nevner avl i én linje. EquiSight bygde en komplett avlsmodul — fordi avleren sjelden er sluttbrukeren av en generell app, men trenger planlegging mer enn noen andre.",
      items: [
        "Følg hoppesyklusen daglig",
        "Inseminasjonsdato + hingstedata",
        "Drektighetssjekk med ultralyd",
        "Forventet fødselsdato + varsler",
        "Føllutviling per måned",
        "Stamtavle og avstamning",
        "Notater per hoppe",
        "Oversikt over alle drektige hopper",
      ],
      ctaLabel: "Se avlsmodulen",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nisje · stall & rideskole",
      title: "Hestestyring for flere hester og pensjonsstaller.",
      lead: "Med flere hester handler det mindre om data og mer om kommunikasjon. Hver eier har egne ønsker, rutiner, fôravtaler og medisinske hensyn. Hver ansatt må ha tilgang til dette uten å måtte lete.",
      cards: [
        {
          t: "Hester per eier",
          d: "Hver eier ser kun sine hester.",
        },
        {
          t: "Stellinstruksjoner",
          d: "Synlig per hest for stallen.",
        },
        {
          t: "Delt kalender",
          d: "Hovslagere, veterinær og konkurranser i én visning.",
        },
        {
          t: "Oppgaveliste",
          d: "Tildel til ansatte, med bekreftelse.",
        },
        {
          t: "Eiertilgang",
          d: "Kunder ser sin hest i egen app.",
        },
        {
          t: "Nødkontakter",
          d: "Alltid tilgjengelig ved stress i stallen.",
        },
      ],
      ctaLabel: "Se rideskolemodulen",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Fra WhatsApp, Excel og whiteboard til EquiSight.",
      lead: "Konkret: slik endrer din daglige hestestyring seg.",
      rows: [
        {
          before: "WhatsApp-grupper",
          after: "Strukturerte notater per hest",
        },
        {
          before: "Excel-ark",
          after: "Levende hestejournal med historikk",
        },
        {
          before: "Whiteboard i stallen",
          after: "Delt planlegging på telefonen",
        },
        {
          before: "Løse bilder i kameraet",
          after: "Medier koblet til din hest",
        },
        {
          before: "Muntlige avtaler",
          after: "Oppgaver og påminnelser med bekreftelse",
        },
        {
          before: "Papirpass på avveie",
          after: "Dokumenter alltid tilgjengelig",
        },
      ],
    },
    helper: {
      title: "Hvilken hestestyring app passer for deg?",
      lead: "Svar på disse 5 spørsmålene og få en ærlig anbefaling — også når svaret ikke alltid er EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Har du én hest eller flere hester?",
          options: [
            {
              label: "Én hest",
              score: 1,
            },
            {
              label: "2–5 hester",
              score: 2,
            },
            {
              label: "Mer enn 5 hester",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Styrer du hester for kunder eller andre?",
          options: [
            {
              label: "Nei, bare mine egne hester",
              score: 0,
            },
            {
              label: "Av og til — for familie eller bekjente",
              score: 1,
            },
            {
              label: "Ja, profesjonelt (stall / rideskole)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Ønsker du å følge avl og drektighet?",
          options: [
            {
              label: "Ikke relevant",
              score: 0,
            },
            {
              label: "Av og til — enkeltvis avl",
              score: 1,
            },
            {
              label: "Ja, jeg er (eller blir) avler",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Samarbeider du med trener, stallansatt eller fagperson?",
          options: [
            {
              label: "Nei, jeg gjør alt selv",
              score: 0,
            },
            {
              label: "Ja, med 1 person",
              score: 1,
            },
            {
              label: "Ja, med flere personer",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vil du bare registrere eller også få innsikt?",
          options: [
            {
              label: "Bare registrere",
              score: 1,
            },
            {
              label: "Registrere + planlegge",
              score: 2,
            },
            {
              label: "Registrere + planlegge + innsikt",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "En enkel loggbok er nok — og vokser med deg.",
          body: "For én hest uten delt omsorg er enhver hestestyring app egnet. EquiSight starter gratis med 1 hest, så du tar ingen risiko. Skulle du senere ønske å legge til flere hester, en trener eller avl, er alt allerede på plass.",
          cta: "Start gratis med 1 hest",
        },
        mid: {
          title: "EquiSight passer godt til din situasjon.",
          body: "Du har flere behov (flere hester, samarbeid eller innsikt). De fleste konkurrentene dekker 1–2 moduler; EquiSight kombinerer dem i én app uten at du må koble sammen separate verktøy.",
          cta: "Se hva EquiSight kan",
        },
        high: {
          title: "EquiSight er det mest naturlige valget.",
          body: "Din situasjon kombinerer flere hester, samarbeid, avl og/eller innsikt. Dette er nøyaktig der EquiSight gjør en forskjell — ingen fragmenterte verktøy, men én hestejournal for alt og alle rundt hesten.",
          cta: "Start gratis med EquiSight",
        },
      },
    },
    faqTitle: "Ofte stilte spørsmål om hestestyring-apper",
    faq: [
      {
        q: "Hva er den beste hestestyring appen?",
        a: "Den beste hestestyring appen avhenger av din situasjon. For en enkel loggbok er flere apper egnet. Ønsker du å kombinere helse, trening, fôring, dokumenter, avl, planlegging og samarbeid, er EquiSight bygget som en komplett løsning der alt samles i én journal.",
      },
      {
        q: "Kan jeg styre flere hester i én app?",
        a: "Ja. En god hestestyring app må støtte flere hester, inkludert eiere, stallansatte, rutiner, dokumenter, avtaler og påminnelser per hest. EquiSight er designet for dette fra første linje kode — hester er individuelle journaler, ikke rader i en liste.",
      },
      {
        q: "Er EquiSight også egnet for avlsvirksomheter?",
        a: "Ja. EquiSight kan settes opp med avlsfunksjoner som hoppesyklus, inseminasjonsdato, drektighetssjekk, hingstedata, stamtavle, forventet fødselsdato og føllutviling. Dette er nøyaktig det området der de fleste konkurrerende apper ikke eller knapt dekker behovet.",
      },
      {
        q: "Kan jeg dele data med min trener eller hovslagere?",
        a: "Ja. Målet med EquiSight er at relevant informasjon trygt kan deles med personer rundt hesten — trener, hovslagere, tannlege, veterinær, fysioterapeut, stallansatt eller eier. Hver person får kun de rettighetene som er nødvendige for sin rolle.",
      },
      {
        q: "Hvorfor ikke bare bruke WhatsApp eller Excel?",
        a: "WhatsApp og Excel fungerer så lenge det er enkelt. Så snart du har flere hester, avtaler, dokumenter, behandlinger, eiere eller avlsdata, blir det feilutsatt: informasjon sprer seg, det tar tid å finne tilbake og muntlige avtaler forsvinner. En hestestyring app samler alt per hest, med automatiske påminnelser.",
      },
      {
        q: "Hva koster EquiSight?",
        a: "Du kan starte gratis med 1 hest. Ønsker du å styre flere hester, aktivere avl eller gi fagpersoner tilgang, finnes det rimelige Premium-planer. Se de gjeldende alternativene på prissiden.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Avlsprogramvare hest: komplett sammenligning 2026",
      description: "Sammenlign avlsprogramvare for hester: hoppesyklus, drektighet, hingstevalg og føll. Se hvorfor EquiSight er den komplette avlsappen.",
      keywords: [
        "avlsprogramvare hest",
        "hoppesyklus app",
        "hoppe drektighet app",
        "følregistrering app",
        "stammbok app hest",
        "dekningsplanlegging hest",
        "hingstevalg app",
      ],
    },
    hero: {
      eyebrow: "Valgguide · avlsprogramvare",
      breadcrumbLabel: "Avlsprogramvare",
      title: "Avlsprogramvare for hester: den komplette sammenligningen for 2026.",
      intro: "En avlshoppe fortjener mer enn en generell hestestyringsapp. Sammenlign avlsfunksjonene til de mest kjente verktøyene, finn ut hva du virkelig bør se etter, og velg bevisst den programvaren som passer ditt stutteri — stort eller lite.",
      pills: [
        {
          icon: "Baby",
          label: "Hoppesyklus",
        },
        {
          icon: "Heart",
          label: "Drektighetskontroll",
        },
        {
          icon: "Sparkles",
          label: "Følutvikling",
        },
        {
          icon: "FileText",
          label: "Stammbok",
        },
      ],
      ctas: [
        {
          label: "Start gratis med avlsmodulen",
          href: "#start",
          primary: true,
        },
        {
          label: "Til sammenligningstabell",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor en vanlig hestestyringsapp ikke er nok for avl.",
      lead: "De fleste hesteapps er utviklet for én sports- eller fritidshest. Avlsvirksomhet har en helt annen rytme: brunst, inseminasjon, drektighetskontroll, ultralyd, følkalender, stamtavle og salg. Én Excel mister oversikten etter 2 sesonger — og med flere hopper mister du kontrollen.",
      items: [
        "Når var egentlig siste syklus til Bonita?",
        "Hvilken hingst er planlagt for dekning neste sesong?",
        "Er 21-dagers ultralyden allerede planlagt?",
        "Hvilke føll fra 2024 er allerede solgt?",
        "Hvor finner jeg stamtavlediagrammet tilbake til morfar?",
        "Hvor er DNA-prøvene og passopplysningene?",
      ],
    },
    what: {
      title: "Hva er avlsprogramvare for hester?",
      lead: "Avlsprogramvare er en spesialisert journal per hoppe og hingst, kombinert med en avlsårskalender, drektighetplanlegging, følregistrering og stamtavlevisning. Ikke en generell hestlogg, men et verktøy som forstår avlssyklusen: fra første brunst til avvenning.",
      targetGroupsTitle: "For hvilken type avler er avlsprogramvare beregnet?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobbyavler (1–3 hopper)",
          body: "Én eller to dekninger per år — oversikt uten Excel-akrobatikk.",
        },
        {
          icon: "Building2",
          title: "Lite stutteri (4–10 hopper)",
          body: "En avlsårsplan med syklus, inseminasjon, drektighetskontroller og føljournal.",
        },
        {
          icon: "Users",
          title: "Profesjonelt stutteri (10+)",
          body: "Flere medarbeidere, hingstevalg per hoppe, salg og markedsføring.",
        },
        {
          icon: "Target",
          title: "Hingsteier",
          body: "Bestillingshistorikk, sædestatistikk og kalender per hingst.",
        },
        {
          icon: "Heart",
          title: "Embryotransplantasjon",
          body: "Donor + mottakerhoppe som koblet journal, ET-kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Stammbokregistrering",
          body: "DNA-prøver, passdokumenter og stamtavledata.",
        },
      ],
    },
    criteria: {
      title: "Hva skal god avlsprogramvare oppfylle?",
      lead: "Ikke alle 'avlsfunksjoner' i en hesteapp er like. Fem kjerneområder der avlere mister mye tid — og der programvare virkelig gjør en forskjell.",
      items: [
        {
          icon: "Calendar",
          title: "Hoppesyklus og brunst",
          body: "Daglig logg, prediktiv ovulasjon, fremrulling per syklus og automatiske påminnelser.",
        },
        {
          icon: "Heart",
          title: "Inseminasjon og drektighetskontroll",
          body: "Deknings- og inseminasjonsdata, hingstedata, 14-dagers ultralyd, 21-dagers ultralyd, 60-dagers ultralyd og kjønnsbestemmelse.",
        },
        {
          icon: "Baby",
          title: "Følutvikling",
          body: "Fødselsdata, vektkurve, ormekurprogram, avvenningsmoment, passregistrering.",
        },
        {
          icon: "FileText",
          title: "Stamtavle og papirer",
          body: "Stamtavlevisning opp til 4–5 generasjoner, DNA, passnumre og stammbok-status.",
        },
        {
          icon: "Target",
          title: "Hingstevalg og matching",
          body: "Filtrering på disiplin, linjer, hingstedata og historisk suksess — ikke bare det en hingsteier promoterer.",
        },
        {
          icon: "Share2",
          title: "Samarbeid med veterinær/inseminator",
          body: "Ultralyd, prøver og statuser delt direkte med praksisen som arbeider med dine hopper.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs annen avlsprogramvare.",
      lead: "Søkeresultatene for avlsprogramvare viser ofte generiske hesteappar som nevner avl i én setning. Vi sammenligner ærlig hvilke verktøy som virkelig har en komplett avlsflyt.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Gratis start",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Logge hoppesyklus",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inseminasjondato + hingst",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultralyd og drektighetskontroll",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Forventet føldate",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Føljournal (vekt/vekst)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Stamtavle til 4–5 generasjoner",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA og passregistrering",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Hingstevalg / matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryotransplantasjon",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Flerhoppe-oversikt",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Deling med veterinær",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrert med generell journal",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Salg og markedsføring av føll",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Sammenligning basert på offentlig tilgjengelige funksjoner per januar 2026. EquineGenie er sterk på avl, men svakere på mobil og generell hestestyring. EquiSight kombinerer begge.",
    },
    why: {
      title: "Hvorfor EquiSight betjener avlere annerledes.",
      lead: "Mange avlere bruker separat avlsprogramvare og en egen hestestyringsapp. EquiSight kombinerer begge — uten at du bytter mellom apper eller registrerer data dobbelt.",
      points: [
        {
          icon: "Heart",
          title: "Avlshoppen er fortsatt en vanlig hest",
          body: "Avlshoppen har en avlsårsjournal og en vanlig hestejournal — helse, vaksinasjoner, hovsmed. Én app, alle moduler.",
        },
        {
          icon: "Sparkles",
          title: "Prediktiv i stedet for reaktiv",
          body: "Syklusprediksjon, drektighetsmilsteinpåminnelser og følkalender — automatisk basert på dine data.",
        },
        {
          icon: "Share2",
          title: "Alle rundt avlsvirksomheten",
          body: "Inseminator, hingsteier, veterinær, kjøper, stammbok — alle med tilgang og riktige rettigheter.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per disiplin · fra syklus til avvenning",
      title: "Hva en avlsjournal i EquiSight inneholder.",
      lead: "Per hoppe får du en komplett avlsjournal, koblet til hennes vanlige hestejournal.",
      items: [
        "Daglig sykluslogg med prediksjon",
        "Inseminasjon/dekning + hingstedata",
        "Ultralydstimlinje (14/21/60 dager + kjønn)",
        "Drektighetsmilsteiner med automatiske påminnelser",
        "Forventet føldate og forberedelser",
        "Føljournal fra fødsel",
        "Stamtavle til besteforeldre med klikk-navigasjon",
        "DNA-prøve, pass, stammbok-status",
        "Salgspipeline med interesserte kjøpere",
        "Hingstevalgshistorikk per hoppe",
      ],
      ctaLabel: "Se avlsmodulen",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "For hele stutteriet",
      title: "Oversikt over flere hopper og hingster.",
      lead: "Når du avler med mer enn 2–3 hopper, blir oversikt over alle sykluser og drektigheter avgjørende.",
      cards: [
        {
          t: "Syklusdashboard",
          d: "Alle hopper side om side, med syklusstadium og neste handling.",
        },
        {
          t: "Drektighetspipeline",
          d: "Hvilke hopper er hvor i drektighetsmilsteinene?",
        },
        {
          t: "Følkalender",
          d: "Forventede fødsler per måned, med logistikk tilpasset deretter.",
        },
        {
          t: "Hingsteportefølje",
          d: "Egne hingster eller faste inseminatorer med bestillingshistorikk.",
        },
        {
          t: "Stamtavlegraf",
          d: "Forfedreanalyse over flere generasjoner og linjer.",
        },
        {
          t: "Salgsdashboard",
          d: "Hvilke føll er solgt, reservert eller fortsatt tilgjengelige.",
        },
      ],
    },
    beforeAfter: {
      title: "Fra Excel og kalender til EquiSight avl.",
      lead: "Konkret: slik endres avlssesongen din.",
      rows: [
        {
          before: "Syklus i løs notis",
          after: "Daglig logg med prediksjon",
        },
        {
          before: "Ultralyd sendt via WhatsApp til inseminator",
          after: "Delt journal med bilder",
        },
        {
          before: "Drektighetsdato i kalender",
          after: "Automatiske milsteinpåminnelser",
        },
        {
          before: "Følpass i skuffen",
          after: "Dokument koblet til følprofil",
        },
        {
          before: "Stamtavle på papir",
          after: "Klikkbar stamtavle til 4–5 generasjoner",
        },
        {
          before: "Salgsannonse på Marktplaats",
          after: "Salgspipeline med interesseliste",
        },
      ],
    },
    helper: {
      title: "Hvilken avlsprogramvare passer for deg?",
      lead: "5 spørsmål for å finne ut om du trenger en komplett avlsapp eller om et hobbyrverktøy er nok.",
      questions: [
        {
          id: "mares",
          q: "Hvor mange avlshopper har du?",
          options: [
            {
              label: "1 hoppe",
              score: 1,
            },
            {
              label: "2–5 hopper",
              score: 2,
            },
            {
              label: "Mer enn 5 hopper",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Hvor ofte avler du per år?",
          options: [
            {
              label: "Sporadisk (hvert par år)",
              score: 0,
            },
            {
              label: "Hvert år 1–2 dekninger",
              score: 2,
            },
            {
              label: "Hvert år 3+ dekninger",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Hvordan inseminerer/dekker du?",
          options: [
            {
              label: "Naturlig dekning",
              score: 1,
            },
            {
              label: "AI fersk/kjølt sæd",
              score: 2,
            },
            {
              label: "ET eller frossen sæd",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Samarbeider du med veterinær/inseminator?",
          options: [
            {
              label: "Én fast person",
              score: 1,
            },
            {
              label: "Flere praksiser",
              score: 2,
            },
            {
              label: "Internasjonalt nettverk",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Hva bruker du i dag?",
          options: [
            {
              label: "Excel eller papir",
              score: 1,
            },
            {
              label: "Generell hestestyringsapp",
              score: 2,
            },
            {
              label: "Ingenting strukturert",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Et hobbyverktøy eller Excel er nok — men EquiSight er fortsatt praktisk.",
          body: "For 1 hoppe med naturlig dekning hvert par år er en avansert avlsmodul overkill. EquiSight starter gratis og du aktiverer avlsmodulen kun for det året du dekker — uten oppgraderingsplikt.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight avl er det riktige verktøyet.",
          body: "Du har flere hopper eller flere avlsmetoder — det er generelle hesteapper ikke bygget for. EquiSight kombinerer avl og generell stell, slik at du slipper å bytte mellom to verktøy.",
          cta: "Se avlsmodulen",
        },
        high: {
          title: "EquiSight er bygget for ditt stutteri.",
          body: "Flere hopper, ET eller frossen sæd, internasjonalt team — de fleste verktøy strekker ikke til her. EquiSight skalerer opp til stutterinivå uten at du stabler ekstra lisenser.",
          cta: "Snakk med oss om en Stutteriplan",
        },
      },
    },
    faqTitle: "Vanlige spørsmål om avlsprogramvare",
    faq: [
      {
        q: "Hva er den beste avlsprogramvaren for hester?",
        a: "For 1 hoppe uten komplisert avlsmetode holder mange verktøy. Fra 2–3 hopper, bruk av AI eller ET, eller samarbeid med veterinær og stammbok, blir en komplett avlsmodul avgjørende. EquiSight kombinerer avl med generell hestestyring i én app, slik at du slipper å bytte.",
      },
      {
        q: "Hvilke avlsfunksjoner trenger jeg egentlig?",
        a: "Minimum: sykluslogg, inseminasjons-/dekningsdata, drektighetsmilsteiner og føljournal. Valgfritt men kraftfullt: stamtavlevisning, hingstevalgsarkiv, DNA/pass og salgspipeline.",
      },
      {
        q: "Kan EquiSight forutsi en hoppes syklus?",
        a: "Ja. EquiSight bruker tidligere syklusdata til å vise prediktert ovulasjon, slik at du kan planlegge inseminasjon eller dekning på riktig tidspunkt — uten daglig gjettelek.",
      },
      {
        q: "Fungerer EquiSight også for embryotransplantasjon?",
        a: "Ja. Donor- og mottakerhoppe får koblede journaler, ET-kalender og delte milsteiner med praksisen. Slik mister du ingen tidslinje i den komplekse ET-flyten.",
      },
      {
        q: "Kan jeg importere eksisterende avlsdata?",
        a: "Du kan registrere syklus, dekninger og føldata manuelt eller i batch via CSV. For aktive avlsvirksomheter hjelper vi med en engangs migrering hvis du har data over flere sesonger.",
      },
      {
        q: "Hvordan deler jeg journalen med veterinæren eller inseminatoren?",
        a: "Hver person får tilgang med en rolle: veterinær, inseminator, hingsteier eller stammbok-funksjonær. Alle ser kun informasjonen som er nødvendig for sin rolle — ingen trenger full tilgang.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Manege programvare: komplett sammenligning & veiledning 2026",
      description: "Sammenlign manege programvare for timer, ryttere, hester og administrasjon. Finn ut hvilken app som passer for din rideskole eller pensjonsstall.",
      keywords: [
        "manege programvare",
        "stallhåndteringsapp",
        "manege administrasjonsprogramvare",
        "timeplanlegging rideskole",
        "pensjonsstall programvare",
        "rytteradministrasjon",
        "heste administrasjon rideskole",
      ],
    },
    hero: {
      eyebrow: "Veiledning · manege programvare",
      breadcrumbLabel: "Manege programvare",
      title: "Manege programvare: den komplette veiledningen for rideskoler og pensjonsstaller.",
      intro: "Timeplanlegging, rytteradministrasjon, hestehåndtering, fakturering og kommunikasjon — god manege programvare samler det hele. Sammenlign de mest kjente alternativene og finn ut hvilken som passer for din stall eller rideskole.",
      pills: [
        {
          icon: "Calendar",
          label: "Timeplanlegging",
        },
        {
          icon: "Users",
          label: "Ryttere & kunder",
        },
        {
          icon: "Heart",
          label: "Hestestell",
        },
        {
          icon: "CreditCard",
          label: "Fakturering",
        },
      ],
      ctas: [
        {
          label: "Be om en demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Til sammenligningstabell",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor spredte verktøy gjør en rideskole treg.",
      lead: "De fleste rideskoler kjører på lappeteppe-løsninger: timeplanlegging på en tavle, rytterregistrering i Excel, fakturering i et annet verktøy, hestestell i WhatsApp og eierkontakt via private meldinger. I en travel uke oppstår dobbeltbookinger, glemte fakturaer eller hester som ikke vet hvilken rytter de får.",
      items: [
        "Hvem er på time hos Jasmijn nå?",
        "Hvilken rytter har ikke betalt for mars?",
        "Hvilken hest kan ikke brukes denne uken?",
        "Hvem er nødkontaktene til elevene?",
        "Har eieren av Stardust mottatt skomakerens faktura?",
        "Hvilken hest står i hvilken boks?",
      ],
    },
    what: {
      title: "Hva er manege programvare?",
      lead: "Manege programvare kombinerer timeplanlegging, rytteradministrasjon, hestehåndtering, fakturering og kommunikasjon i ett verktøy. Ingen Excel-akrobatikk eller WhatsApp-kaos, men ett sted der rideskojen jobber og eiere/ryttere kan følge med.",
      targetGroupsTitle: "Hvilken type virksomhet er manege programvare beregnet for?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Liten rideskole (1–15 hester)",
          body: "Primært timeplanlegging og betalinger — administrasjon uten hodepine.",
        },
        {
          icon: "Users",
          title: "Mellomstor rideskole (15–40 hester)",
          body: "Flere instruktører, timeplan + hesteskjema + rytteradministrasjon.",
        },
        {
          icon: "ClipboardList",
          title: "Stor ride- og pensjonsstall (40+)",
          body: "Full drift inkludert fakturering, fôr- og skomakerplanlegging.",
        },
        {
          icon: "Heart",
          title: "Pensjonsstall",
          body: "Eierportal, individuelle stelleinstruksjoner, delt kalender.",
        },
        {
          icon: "Target",
          title: "Treningsstall for hoppryttere",
          body: "Konkurranseplanlegging, trening per hest, kundekontakt.",
        },
        {
          icon: "FileText",
          title: "Hestesportgründere",
          body: "Mix av timer + pensjon + klinikk + handel — alt fra ett system.",
        },
      ],
    },
    criteria: {
      title: "Hva kjennetegner god manege programvare?",
      lead: "En fin app betyr ingenting hvis medarbeiderne dine ikke vil bruke den. Fem praktiske kriterier som gjør forskjellen mellom suksess og frustrasjon.",
      items: [
        {
          icon: "Calendar",
          title: "Timeplanlegging på flere nivåer",
          body: "Nybegynner/viderekomne, dressur/hopp, hestekoblinger og instruktørkalendere — alt synlig side om side.",
        },
        {
          icon: "Users",
          title: "Rytteradministrasjon",
          body: "Profiler, nivå, abonnement, timekort og familiemedlemskoblinger for ungryttere.",
        },
        {
          icon: "Heart",
          title: "Hesteskjema",
          body: "Hvilken hest brukes hvor ofte, med hvile-, skade- og behandlingsperioder.",
        },
        {
          icon: "CreditCard",
          title: "Fakturering & abonnementer",
          body: "Månedlige abonnementer, timekort, enkeltimer og automatisk trekk.",
        },
        {
          icon: "Share2",
          title: "Eierportal (pensjonsstall)",
          body: "Eiere ser hesten sin i egen app — kalender, kostnader, skomaker og notater uten å ringe.",
        },
        {
          icon: "Bell",
          title: "Kommunikasjon & påminnelser",
          body: "Automatiske timepåminnelser, betalingsvarsler, skomaker-kunngjøringer — uten meldingskaos.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs annen manege programvare.",
      lead: "Mange manege-verktøy er sterke på timeplanlegging eller fakturering, men sjelden på hestestell og eierkommunikasjon samtidig. Vi sammenligner dem ærlig side om side.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Gratis start / prøveperiode",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Timeplanlegging",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Flere instruktører",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rytteradministrasjon",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hesteskjema",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hestestell (vaksinasjon/skomaker)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Timekort / abonnement",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Nettbetalinger",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatisk fakturering",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Eierportal (pensjon)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Skomaker/veterinær-integrasjon",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS-påminnelser",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Konkurranseplanlegging",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Egnet for pensjonsstall",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Sammenligning basert på offentlig tilgjengelige funksjoner per januar 2026. Stalmanager er sterk på administrasjon, EquiSight skiller seg ut med pensjonsstall-flyt + hestestell + eierportal.",
    },
    why: {
      title: "Hvorfor EquiSight er annerledes for rideskoler og pensjonsstaller.",
      lead: "EquiSight går lenger enn en timeplanlegger. Vi ser på en rideskole som en komplett operasjon: hester, mennesker, kommunikasjon og økonomi — alle avhengige av hverandre.",
      points: [
        {
          icon: "Heart",
          title: "Hesten i sentrum, ikke kalenderen",
          body: "Hver hest har sin egen journal. Timebruk, helse, skomaker og konkurranser i én tidslinje — ikke 3 separate verktøy.",
        },
        {
          icon: "Share2",
          title: "Eiere følger med uten å ringe",
          body: "Pensjonsstall-eiere har sin egen visning: kostnader, planlegging, bilder og notater — sparer 5–10 telefonsamtaler per uke.",
        },
        {
          icon: "Bell",
          title: "Automatisk kommunikasjon",
          body: "Timepåminnelse, vaksinasjonspåminnelse, faktura — automatisk, via app/e-post/SMS. Ingen masse-WhatsApp mer.",
        },
      ],
    },
    nicheB: {
      eyebrow: "For pensjonsstallen",
      title: "Hva en pensjonsstall får med EquiSight.",
      lead: "Pensjonsstaller har unike utfordringer som vanlig manege programvare ikke løser.",
      cards: [
        {
          t: "Eierportal",
          d: "Hver eier ser kun sine egne hester, kalender og kostnader.",
        },
        {
          t: "Stelleinstruksjoner per hest",
          d: "Fôr, grovfôr, tilskudd, dekkenplan — synlig for stallen.",
        },
        {
          t: "Delt kalender",
          d: "Skomaker, veterinær og eierbesøk i én visning.",
        },
        {
          t: "Forbrukskostnader per hest",
          d: "Strø, fôr, kraftfôr belastet per eier.",
        },
        {
          t: "Nødkontakter for hest",
          d: "Eier + veterinær + skomaker alltid tilgjengelig for stallen.",
        },
        {
          t: "Beiteadministrasjon",
          d: "Hvilke hester går på beite, er på hvile eller i rehabilitering?",
        },
      ],
    },
    beforeAfter: {
      title: "Fra tavle + Excel til EquiSight.",
      lead: "Konkret: slik endres en arbeidsuke på rideskojen.",
      rows: [
        {
          before: "Tavle med timeplanlegging",
          after: "Direkteoppdatert plan per instruktør",
        },
        {
          before: "Excel med ryttere + timenotater",
          after: "Kunde-CRM med timehistorikk",
        },
        {
          before: "WhatsApp til eiere",
          after: "Eierportal for deres hest",
        },
        {
          before: "Månedlig trekk manuelt",
          after: "Automatisk fakturering + iDEAL",
        },
        {
          before: "Hestestell på en papirlapp-tavle",
          after: "Stelleinstruksjoner per hest, delt",
        },
        {
          before: "Muntlig avtale med skomaker",
          after: "Skomakerplanlegging med bekreftelser",
        },
      ],
    },
    helper: {
      title: "Hvilken manege programvare passer for deg?",
      lead: "5 spørsmål for å se om EquiSight er den rette plattformen for din rideskole eller pensjonsstall.",
      questions: [
        {
          id: "size",
          q: "Hvor mange hester har du i virksomheten din?",
          options: [
            {
              label: "Færre enn 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Mer enn 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Hva er din hovedaktivitet?",
          options: [
            {
              label: "Primært rideopplæring",
              score: 1,
            },
            {
              label: "Pensjonsstall (hester i pensjon)",
              score: 3,
            },
            {
              label: "Mix av timer + pensjon",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Hvor mange instruktører jobber du med?",
          options: [
            {
              label: "Bare meg selv",
              score: 1,
            },
            {
              label: "2–3 instruktører",
              score: 2,
            },
            {
              label: "4 eller flere",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Hvordan håndterer du fakturering nå?",
          options: [
            {
              label: "Manuelt (Word/Excel)",
              score: 3,
            },
            {
              label: "Separat regnskapsprogram",
              score: 2,
            },
            {
              label: "Integrert i timeverktøy",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Hvordan kommuniserer du med eiere?",
          options: [
            {
              label: "Personlig / WhatsApp",
              score: 3,
            },
            {
              label: "E-post + WhatsApp",
              score: 2,
            },
            {
              label: "Eierportal i verktøyet",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Et enkelt verktøy eller Excel kan holde foreløpig — men EquiSight skalerer med deg.",
          body: "For en liten rideskole med én instruktør og lite pensjon er en avansert løsning ikke nødvendig med en gang. EquiSight starter gratis og vokser med rideskojen din — ingen migreringshodepine om noen år.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight er en naturlig oppgradering for din rideskole.",
          body: "Flere instruktører, en mix av timer og pensjon, eller fakturering som nå er adskilt — EquiSight samler det i én arbeidsflyt. Spesielt eierportalen sparer mye ad-hoc-kommunikasjon.",
          cta: "Be om en demo",
        },
        high: {
          title: "EquiSight er bygget for din skala.",
          body: "Pensjonsstall + timer + flere instruktører er nettopp der EquiSight skiller seg fra klassiske manege-verktøy. Eierportalen og hestestell-integrasjonen sparer timevis med administrasjon og kommunikasjon hver uke.",
          cta: "Planlegg en demo for din stall",
        },
      },
    },
    faqTitle: "Vanlige spørsmål om manege programvare",
    faq: [
      {
        q: "Hva er den beste manege programvaren?",
        a: "For ren timeplanlegging finnes det flere gode alternativer. Når du trenger pensjonsstall, flere instruktører eller hestestell-sporing, blir EquiSight den komplette løsningen — ingen verktøy-jonglering, alt på ett sted.",
      },
      {
        q: "Kan jeg importere eksisterende kunder og timer?",
        a: "Ja. Kundedata og timeskjemaer kan importeres via CSV. Vi hjelper aktive rideskoler med en engangsmigrasjon slik at du slipper å legge inn 200 ryttere manuelt.",
      },
      {
        q: "Fungerer det også for en pensjonsstall uten timer?",
        a: "Ja. Pensjonsstall-modus slår av timer og fokuserer på eierportal, fôr/stell, skomakerplanlegging og kostnadsbetaling per hest.",
      },
      {
        q: "Kan ryttere selv melde seg på og betale?",
        a: "Ja. Ryttere kan via sin egen konto se hvilke timer som er ledige, melde seg på, betale timepenger med iDEAL og kjøpe timekort.",
      },
      {
        q: "Hva med personvern for heste- og eierdata?",
        a: "Hver person har en rolle (eier, rytter, instruktør, ansatt). Per rolle ser du bare det du trenger. Eiere ser kun sin hest, ryttere kun sine egne timer.",
      },
      {
        q: "Kan EquiSight kobles til regnskapsprogrammet mitt?",
        a: "Ja, integrasjoner med Exact, Moneybird og e-Boekhouden er tilgjengelige. Fakturaer flyter da automatisk over til regnskapet ditt.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trener-app hest: sammenligning & veiledning for coacher 2026",
      description: "Sammenlign trener-apper for hest og rytter: treningslogg, video, mål, protokollanalyse og kundehåndtering. Finn riktig verktøy for coacher.",
      keywords: [
        "trener-app hest",
        "instruktør-app",
        "hest trenings-app",
        "rytter coaching-app",
        "treningsdagbok hest",
        "dressurprotokoll analysere",
        "hestetrenerprogramvare",
      ],
    },
    hero: {
      eyebrow: "Veiledning · trenerprogramvare",
      breadcrumbLabel: "Trener-app",
      title: "Trener-app hest: komplett veiledning for instruktører og coacher.",
      intro: "En trener eller instruktør jonglerer med kombinasjoner, timer, videoer, mål og konkurranser. Sammenlign de beste trener-appene for hestemennnesker og velg plattformen som også i 2026 vokser med din coaching.",
      pills: [
        {
          icon: "Target",
          label: "Mål & planlegging",
        },
        {
          icon: "Video",
          label: "Videoanalyse",
        },
        {
          icon: "TrendingUp",
          label: "Fremgang",
        },
        {
          icon: "Users",
          label: "Kunder/kombinasjoner",
        },
      ],
      ctas: [
        {
          label: "Start gratis som trener",
          href: "#start",
          primary: true,
        },
        {
          label: "Til sammenligningstabell",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Hvorfor WhatsApp-coaching hindrer trenere.",
      lead: "De fleste trenere bruker løse verktøy: WhatsApp til kommunikasjon, en notatbok til timer, YouTube eller WeTransfer til videoer og Excel til konkurranseresultater. Med 5 ryttere fungerer det. Med 20 ryttere går informasjon tapt, du glemmer mål og mister oversikten over individuell fremgang.",
      items: [
        "Hva er Anouks mål for denne sesongen?",
        "Hvilken video sendte jeg til Bram forrige måned?",
        "Har Lara sett protokollanalysen fra siste konkurranse?",
        "Hvilken kombinasjon trener hvor ofte per uke?",
        "Har eieren av Stardust lest treningsinstruksjonen min?",
        "Når ga jeg sist tilbakemelding på ustabil impuls?",
      ],
    },
    what: {
      title: "Hva er en trener-app for hest og rytter?",
      lead: "En trener-app kombinerer et coaching-CRM (kombinasjoner, timer, mål), en treningslogg per hest, videotilbakemelding, konkurranseplanlegging og protokollanalyse. Ikke mer løst WhatsApp/YouTube/Excel, men én plattform der trener og rytter jobber sammen.",
      targetGroupsTitle: "Hvilken type trener er dette beregnet for?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dressyrinstruktør",
          body: "Skann protokoller, koble dommertkommentarer til treningsmål, se fremgang.",
        },
        {
          icon: "Activity",
          title: "Hoppetrener",
          body: "Baneplanlegging, omgangstilbakemelding, hindringsstyring per hest.",
        },
        {
          icon: "Award",
          title: "Eventing-coach",
          body: "Tre disipliner, tre planer – alle synlige side om side.",
        },
        {
          icon: "TrendingUp",
          title: "Prestasjonscoach (sport)",
          body: "EPI-sporing, konkurranser, mål — for toppidrettsutøvere og teamene deres.",
        },
        {
          icon: "Users",
          title: "Ridesenters instruktør",
          body: "Gruppetimer + individuell coaching i én app.",
        },
        {
          icon: "Heart",
          title: "Rekreasjonscoach",
          body: "Hesteassistert terapi, nybegynnere, eiere med én hest.",
        },
      ],
    },
    criteria: {
      title: "Hva bør en god trener-app oppfylle?",
      lead: "Trening er menneskelig arbeid, men riktig verktøy gjør deg 30–50 % mer effektiv og hjelper ryttere å bli bedre også mellom timene.",
      items: [
        {
          icon: "Users",
          title: "Kombinasjonshåndtering",
          body: "Hest + rytter som én enhet, med nivå, mål, fremgang og historikk.",
        },
        {
          icon: "ClipboardList",
          title: "Timenotater & mål",
          body: "Et notat med fokuspunkter per time, koblet til langsiktige mål.",
        },
        {
          icon: "Video",
          title: "Videotilbakemelding",
          body: "Last opp video, merk øyeblikk, legg til tale- eller skriftlig tilbakemelding.",
        },
        {
          icon: "Target",
          title: "Konkurranse- & protokollanalyse",
          body: "Skann protokoller (KNHS/FEI), se poengsum per element, dommerkommentarer og trender.",
        },
        {
          icon: "Calendar",
          title: "Planlegging & timekort",
          body: "Kalender, betalinger, abonnementer og automatiske påminnelser.",
        },
        {
          icon: "Share2",
          title: "Kommunikasjon til rytter",
          body: "Rytteren ser sin egen side med timer, videoer, mål og tilbakemeldinger.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andre trener-apper.",
      lead: "Noen treneverktøy fokuserer på å erstatte WhatsApp, andre på protokollanalyse. EquiSight kombinerer begge med en ekte hestemappe – slik at rytteren også blir bedre mellom timene.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Start gratis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinasjonshåndtering",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Timenotater & tilbakemelding",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Langsiktige mål",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Videoopplasting + tilbakemelding",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokollskanning",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Prestasjonsindeks)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Konkurransekalender",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rytterportal",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Timekort / abonnement",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Nettbetalinger",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrert hestemappa",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Skomaker/veterinær synlig",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "For instruktør OG rytter",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Flere hester per rytter",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Sammenligning basert på offentlig tilgjengelige funksjoner i januar 2026. EquiSight er unikt i protokollanalyse + EPI og kombinerer dette med generell hesteforvaltning.",
    },
    why: {
      title: "Hvorfor EquiSight gir en annerledes treneropplevelse.",
      lead: "De fleste treneverktøy slutter der timen er over. EquiSight fortsetter – i hestemappa, i konkurranseanalysen, i samarbeidet med veterinær og eier.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokollskann → treningsmål",
          body: "Skann et KNHS-protokoll og se direkte hvilke elementer som trenger oppmerksomhet. Mål dukker automatisk opp.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach styrker blikket ditt",
          body: "Data fra flere timer, konkurranser og protokoller avslører mønstre du ikke kan holde styr på i hodet.",
        },
        {
          icon: "Share2",
          title: "Integrert med hesten",
          body: "Treneren ser vaksinasjon, skomaker og skadehistorikk for hesten – ingen trening planlegges under rehabilitering.",
        },
      ],
    },
    nicheA: {
      eyebrow: "For dressyr og hopp",
      title: "Hva et coaching-dossier i EquiSight inneholder.",
      lead: "Per kombinasjon får du en coaching-strøm som holder alt samlet – ikke mer tapt informasjon i WhatsApp.",
      items: [
        "Timenotater med fokuspunkter per økt",
        "Langsiktige mål + milepæler",
        "Videoopplasting med tidskodekommentarer",
        "KNHS/FEI protokollskanning med poengsum",
        "Dommerkommentarer koblet til trening",
        "Konkurranseresultater og EPI-trend",
        "Kundekontakt og timehistorikk",
        "Timekort / abonnement / fakturaer",
        "Fremgangsgrafikk per disiplin",
        "Delt tilgang med hesteeier",
      ],
      ctaLabel: "Se trenermodulen",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Fra WhatsApp + YouTube til EquiSight Trener.",
      lead: "Konkret: slik endres coaching-arbeidsflyten din.",
      rows: [
        {
          before: "WhatsApp med løse videolenker",
          after: "Video med tidskode-tilbakemelding i mappa",
        },
        {
          before: "Notatbok per rytter",
          after: "Coaching-logg med mål + historikk",
        },
        {
          before: "Excel med konkurransepoeng",
          after: "EPI-grafik + protokollanalyse",
        },
        {
          before: "Muntlige mål",
          after: "Milepæler med fremgangsindikator",
        },
        {
          before: "Separat faktureringsverktøy",
          after: "Timer + iDEAL + abonnement i app",
        },
        {
          before: "E-post til eier om fremgang",
          after: "Eier følger med i egen visning",
        },
      ],
    },
    helper: {
      title: "Hvilken trener-app passer for deg?",
      lead: "5 spørsmål for å se om et spesialisert coaching-verktøy gir merverdi for din praksis.",
      questions: [
        {
          id: "clients",
          q: "Hvor mange aktive kombinasjoner coacher du?",
          options: [
            {
              label: "Færre enn 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Mer enn 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Hva er hoveddisiplinen din?",
          options: [
            {
              label: "Dressyr",
              score: 3,
            },
            {
              label: "Hopp",
              score: 2,
            },
            {
              label: "Rekreasjon / blandet",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Bruker du video i coaching?",
          options: [
            {
              label: "Sjelden",
              score: 0,
            },
            {
              label: "Av og til (manuelt)",
              score: 2,
            },
            {
              label: "Ofte – systematisk",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Coacher du konkurranseryttere?",
          options: [
            {
              label: "Nei, rekreasjonsryttere",
              score: 0,
            },
            {
              label: "Noen ganger konkurranser",
              score: 2,
            },
            {
              label: "Mye – startlister sentralt",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vil du måle coachingen din?",
          options: [
            {
              label: "Nei, intuisjon er nok",
              score: 0,
            },
            {
              label: "Ja, men ikke tid",
              score: 2,
            },
            {
              label: "Ja – datadriven coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Et enkelt verktøy eller til og med WhatsApp er nok – for nå.",
          body: "For færre enn 5 ryttere uten mye video eller konkurranser er en coaching-app overkill. EquiSight starter gratis, så du kan prøve det når praksisen din vokser.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight Trener gjør deg strukturelt mer effektiv.",
          body: "Med 5–15 kombinasjoner mister du timer per måned på WhatsApp og løse videoer. EquiSight samler alt, skanner protokoller automatisk og sørger for at ryttere alltid kan se tilbakemeldingene sine.",
          cta: "Prøv Trener-modulen",
        },
        high: {
          title: "EquiSight er bygget for din coaching-skala.",
          body: "Mange ryttere, video, konkurranser og datadriven coaching: dette er nøyaktig der EquiSight skiller seg ut. EPI + protokollskanning + hestemappa gir deg et forsprang konkurrentene ikke har.",
          cta: "Planlegg en demo for din coachingpraksis",
        },
      },
    },
    faqTitle: "Ofte stilte spørsmål om trener-apper",
    faq: [
      {
        q: "Hva er den beste trener-appen for hest og rytter?",
        a: "For ren kommunikasjon holder mange verktøy (selv WhatsApp). For mål, videoanalyse, protokollskanning, konkurransesporing og kundehåndtering i ett verktøy er EquiSight den mest komplette løsningen – særlig fordi den også holder styr på selve hesten, ikke bare kombinasjonen.",
      },
      {
        q: "Kan EquiSight lese konkurranseprotokoller automatisk?",
        a: "Ja. Last opp et KNHS- eller FEI-protokoll, og EquiSight henter ut poengsum per element, dommerkommentarer og kobler dette til kombinasjonen. Trender vises over flere konkurranser.",
      },
      {
        q: "Hva er EPI (Equestrian Performance Index)?",
        a: "EPI er en EquiSight-score som omgjør flere konkurranseresultater til en sammenlignbar prestasjonsindeks. Dermed ser du reell fremgang på tvers av ulike klasser og dommere.",
      },
      {
        q: "Kan ryttere booke og betale for timene selv?",
        a: "Ja. Ryttere logger inn, ser tilgjengelige timeavtaler, kjøper timekort og betaler via iDEAL. Du godkjenner hva du ønsker å tilby.",
      },
      {
        q: "Fungerer det også for en instruktør som arbeider rundt rideskolen?",
        a: "Ja. Du kan jobbe som frilans trener med egne kunder uten å koble til en ridesenters konto. Kundene betaler deg direkte.",
      },
      {
        q: "Kan jeg migrere eksisterende videoer og notater?",
        a: "Videoer kan du laste opp per kombinasjon eller via et batch-opplastingsverktøy. Notater importeres via CSV. Vi hjelper aktive trenere med en engangsmigrering.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guider & valgverktøy for hesteforvaltningsprogramvare | EquiSight",
      description: "Alle EquiSight-guider på ett sted: sammenligninger av hesteforvaltning, avl, rideskole og trenerprogramvare, pluss valgverktøy for 2026.",
      keywords: [
        "hesteprogramvare guider",
        "hesteforvaltning valgverktøy",
        "avlsprogramvare sammenligning",
        "rideskole programvare guide",
        "trener-app sammenligning",
      ],
    },
    hub: {
      eyebrow: "Hub · guider",
      breadcrumbLabel: "Guider",
      title: "Fire komplette guider for å velge riktig hesteprogramvare.",
      intro: "En grundig valgguide for hver målgruppe: sammenligingstabeller, kriterier, eksempler og interaktiv quiz. Klikk deg videre til guiden som passer din situasjon, eller utforsk de utdypende artiklene under hver klynge.",
      stats: {
        guides: "4 valgverktøy",
        articles: "15 utdypende artikler",
        fair: "Ærlig sammenligning",
      },
      readMoreCta: "Les den komplette guiden",
      relatedHeading: "Utdypende artikler",
      articlesCountSingular: "{{count}} utdypende artikkel",
      articlesCountPlural: "{{count}} utdypende artikler",
      articlesCountAria: "Antall klynge-artikler",
      lastUpdatedPrefix: "Oppdatert",
      lastUpdatedAria: "Dato for siste oppdatering av denne klyngen",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Valgguide for hesteforvaltningsapp",
        blurb: "Sammenlign de mest kjente hesteforvaltningsappene og finn ut hvilken som passer for eier, stall eller avlsvirksomhet. Inkludert ærlig sammenligningstabell og valgverktøy med 5 spørsmål.",
        audience: "For hesteiere, stallholdere og alle hestemennesker som ønsker oversikt.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Sammenligning av avlsprogramvare",
        blurb: "Fra hoppe-syklus til følutvikling: se hvilken avlsprogramvare som virkelig fungerer for ditt antall hopper, avlsmetode og stammebokskrav.",
        audience: "For (hobby)avlere, stutterier og hingsteiere.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Valgguide for rideskoleprogramvare",
        blurb: "Timeplanlegging, rytteradministrasjon, eierportal og fakturering — i ett verktøy. Sammenlign alternativene for rideskoler og pensjonssstaller i 2026.",
        audience: "For rideskoler, pensjonsstaller og ridevirksomheter.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Valgguide for trener-app",
        blurb: "Coaching-CRM, videorespons, skanning av KNHS-protokoll og mål per kombinasjon. Hvilken trener-app passer for din coachingpraksis?",
        audience: "For instruktører, trenere og coacher.",
      },
    ],
    closing: {
      eyebrow: "Hvorfor disse guidene",
      title: "Ærlig sammenligning, ikke bare priser.",
      body1: "Mange \"sammenligningssider\" er skjulte reklamer. Guidene våre stiller funksjoner, målgrupper og konkurrenter opp mot hverandre slik en uavhengig kunnskapskilde ville gjort. EquiSight fremstår naturligvis som en komplett løsning, men du leser også ærlig om hvor andre apper er sterkere.",
      body2: "De utdypende artiklene under hver guide besvarer de konkrete spørsmålene som oppstår etter valget: \"Når er første ultralyd etter inseminasjon\", \"Hvordan automatiserer jeg fakturering for rideskolen\", \"Hvordan analyserer jeg en konkurranseprotokoll\". Ingen markedsføringsfluff, bare praksis.",
    },
    hubName: "EquiSight Guider",
  },
  ui: {
    sectionEyebrows: {
      pains: "Hvorfor dette gjør vondt",
      basics: "Grunnleggende",
      criteria: "Hva gjør det bra?",
      comparison: "Ærlig sammenligning",
      why: "Forskjellen",
      beforeAfter: "Fra fragmentering til oversikt",
      helper: "5 spørsmål",
    },
    table: {
      feature: "Funksjon",
      today: "I dag",
      withEquisight: "Med EquiSight",
    },
    helper: {
      questionLabel: "Spørsmål {{current}} av {{total}}",
      answerPrompt: "Svar på det {{count}} gjenværende spørsmålet for å se en anbefaling.",
      answerPromptPlural: "Svar på de {{count}} gjenværende spørsmålene for å se en anbefaling.",
      resultEyebrow: "Ditt resultat",
    },
    targetGroupsFallback: "Hvem er dette for?",
    faqTitleFallback: "Ofte stilte spørsmål",
  },
};

export default CORNERSTONES;
